'use client';

import { useEffect, useRef } from 'react';

import { usePathname, useSearchParams } from 'next/navigation';
import Script from 'next/script';

import { WindowWithDataLayer, trackDatalayer, trackSubrite } from 'utils/analytics';

declare const window: WindowWithDataLayer;

type AnalyticsProps = {
  userId?: string | number;
  subriteTrackerId?: string;
};

function Analytics({ userId, subriteTrackerId }: AnalyticsProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const searchParamsText = searchParams ? searchParams.toString() : '';
  const initialPageViewRef = useRef(true);
  const url = `${pathname}${searchParamsText}`;

  useEffect(() => {
    let initialPageView = false;
    if (initialPageViewRef.current) {
      initialPageView = true;
      initialPageViewRef.current = false;
    } else {
      initialPageView = false;
      trackSubrite(url, false); // Do not track on first pageview. This is done by the script
    }
    trackDatalayer(url, initialPageView);
  }, [url]);

  useEffect(() => {
    if (userId) {
      // if window.subriteAnalytics is none existing, this will be handeled by the script
      if (typeof window.subriteAnalytics !== 'undefined') {
        window.subriteAnalytics.identify({
          user_id: userId,
        });
      }
    }
  }, [userId]);

  if (!subriteTrackerId) {
    return null;
  }

  return (
    <Script
      src="https://analytics.subrite.no/script.js"
      onLoad={() => {
        // Ensure window.subriteAnalytics is initialized before calling init
        if (
          window &&
          window.subriteAnalytics &&
          typeof window.subriteAnalytics.init === 'function'
        ) {
          window.subriteAnalytics.init(subriteTrackerId);
          if (userId) {
            window.subriteAnalytics.identify({
              user_id: userId,
            });
          }
        } else {
          console.log(
            'Subrite tracker script loaded, but window.subriteAnalytics is not available.',
          );
        }
        trackSubrite(url, true);
      }}
    />
  );
}

export default Analytics;
